import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Footer({ contact, products }) {
  return (
    <footer className="border-t border-white/10 bg-[#0A0C0F]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white rounded-xl px-3 py-2 inline-block">
            <img src="/logo.png" alt="A-Z Concepts UK Ltd" className="h-9 w-auto" />
          </div>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed">
            UK sublimation printing house and wholesale garment manufacturer. Custom hoodies, sportswear, tracksuits and more — factory-direct.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-slate-300">Products</h4>
          <ul className="mt-4 space-y-2.5">
            {products.map((p) => (
              <li key={p.id}>
                <a href={`/products/${p.id}`} data-testid={`footer-product-link-${p.id}`} className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">{p.name}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-slate-300">Company</h4>
          <ul className="mt-4 space-y-2.5">
            <li><a href="/sublimation" data-testid="footer-link-sublimation" className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">Sublimation Printing</a></li>
            <li><a href="#why-us" data-testid="footer-link-why-us" className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">Why Choose Us</a></li>
            <li><a href="#about" data-testid="footer-link-about" className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">About Us</a></li>
            <li><a href="#enquiry" data-testid="footer-link-quote" className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">Request a Quote</a></li>
            <li><Link to="/admin/login" data-testid="footer-link-owner-login" className="text-sm text-slate-500 hover:text-[#FF5A1F] transition-colors">Owner Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-slate-300">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2.5"><Phone size={15} className="text-[#FF5A1F]" /> <a href={`tel:${contact.phone}`} data-testid="footer-phone-link" className="hover:text-white transition-colors">{contact.phone}</a></li>
            <li className="flex items-center gap-2.5"><MessageCircle size={15} className="text-[#25D366]" /> <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="hover:text-white transition-colors">WhatsApp us</a></li>
            <li className="flex items-center gap-2.5"><Mail size={15} className="text-[#2563EB]" /> <a href={`mailto:${contact.email}`} data-testid="footer-email-link" className="hover:text-white transition-colors">{contact.email}</a></li>
            <li className="flex items-start gap-2.5"><MapPin size={15} className="text-[#10B981] mt-0.5" /> <span>{contact.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} AZ Concepts UK Ltd — azconcepts.net. All rights reserved.</p>
          <p className="text-xs text-slate-600">Sublimation Printing · Wholesale Hoodies · Custom Sportswear · OEM Garments</p>
        </div>
      </div>
    </footer>
  );
}
